module.exports = __webpack_public_path__ + "assets/img/572ea411e39d174c4e4b4e70a04ab052.svg";